import React, { useMemo, useEffect } from 'react'
import { useTable, useRowSelect } from 'react-table'
import clsx from 'clsx'
import UserItem from './TableItem'
import EditableCell from './EditableCell'
import Checkbox from '../../../components/CheckBox'

const UserTable = function ({
  data,
  userNames,
  mobiles,
  existNames,
  existMobiles,
  updateCheckedUser,
  updateMyData,
  updateIsVerifyPass,
  updateAddPower,
  updateWrongNum,
  resetData,
}) {
  const datas = useMemo(() => data || [], [data])
  const columns = useMemo(
    () => [
      {
        id: 'name',
        Header: '姓名',
        accessor: 'name',
      },
      {
        id: 'username',
        Header: '用户名',
        accessor: 'username',
      },
      {
        id: 'password',
        Header: '密码',
        accessor: 'password',
      },
      {
        id: 'repeatpwd',
        Header: '重复密码',
        accessor: 'repeatpwd',
      },
      {
        id: 'mobile',
        Header: '手机号',
        accessor: 'mobile',
      },
      {
        id: 'tip',
        Header: '提示',
        accessor: 'tip',
      },
      {
        id: 'operate',
        Header: '操作',
        accessor: 'operate',
      },
    ],
    []
  )
  const defaultColumn = {
    Cell: EditableCell,
  }

  const tableInstance = useTable(
    { columns, data: datas, updateMyData, defaultColumn },
    useRowSelect,
    (hooks) => {
      hooks.visibleColumns.push(() => [
        {
          id: 'selection',
          width: 100,
          // eslint-disable-next-line react/no-unstable-nested-components
          Header: ({ getToggleAllRowsSelectedProps }) => (
            <Checkbox {...getToggleAllRowsSelectedProps()} />
          ),
          // eslint-disable-next-line react/no-unstable-nested-components
          Cell: ({ row }) => <Checkbox {...row.getToggleRowSelectedProps()} />,
        },
        ...columns,
      ])
    }
  )
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    selectedFlatRows,
  } = tableInstance

  useEffect(() => {
    updateCheckedUser(selectedFlatRows.map((d) => d.original))
  }, [selectedFlatRows])

  useEffect(() => {
    const isCanAdd = rows.every((i) => i.cells[6].value === true)
    const failedUsers = rows.filter((i) => i.cells[6].value !== true)
    updateWrongNum(failedUsers.length)
    if (isCanAdd) {
      updateAddPower(true)
    } else {
      updateAddPower(false)
    }
    if (rows.length === 0) {
      resetData()
    }
  }, [rows])

  return (
    <table
      {...getTableProps()}
      className="rounded-md w-full overflow-x-auto h-full relative"
      style={{ fontSize: '0.875rem', height: 'calc(100vh - 400px)' }}
    >
      <thead>
        {headerGroups.map((headerGroup) => {
          return (
            <tr
              {...headerGroup.getHeaderGroupProps()}
              key={headerGroup.headers}
              className="flex pl-4"
              style={{
                fontSize: '13px',
                borderBottom: '1px solid #dbdfea',
                borderTop: '1px solid #dbdfea',
              }}
            >
              {headerGroup.headers.map((column) => {
                return (
                  <div
                    {...column.getHeaderProps()}
                    key={column.id}
                    className={clsx([
                      {
                        'w-32 lg:w-1/6':
                          column.id !== 'selection' && column.id !== 'operate',
                        'w-10': column.id === 'selection',
                        'w-16 lg:w-1/6': column.id === 'operate',
                        'item-name': column.id === 'name',
                      },
                      'flex items-center p-2',
                    ])}
                  >
                    <b>{column.render('Header')}</b>
                  </div>
                )
              })}
            </tr>
          )
        })}
      </thead>
      <tbody
        {...getTableBodyProps()}
        className="overflow-y-auto content absolute w-full"
        style={{ height: 'calc( 100% - 3rem )', top: '50px' }}
      >
        {rows.map((row, index) => {
          prepareRow(row)
          return (
            <UserItem
              row={row}
              userNames={userNames}
              existNames={existNames[index]}
              existMobiles={existMobiles[index]}
              key={row.original.id}
              deleteUser={updateMyData}
              mobiles={mobiles}
              updatePassData={updateMyData}
              updateIsVerifyPass={updateIsVerifyPass}
            />
          )
        })}
      </tbody>
    </table>
  )
}

export default UserTable
